"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = HR;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _theme = require("HubStyleTokens/theme");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _tshirtSize = require("../utils/propTypes/tshirtSize");

var _Styles = require("../utils/Styles");

var StyledHR = _styledComponents.default.hr.withConfig({
  displayName: "HR__StyledHR",
  componentId: "cl4vdb-0"
})(["background-color:", ";border:0;height:1px;min-height:1px;width:100%;", ";"], _theme.HR_BORDER_COLOR, function (_ref) {
  var distance = _ref.distance;
  return (0, _Styles.setDistance)(distance);
});

function HR(props) {
  return _react.default.createElement(StyledHR, props);
}

HR.propTypes = {
  distance: _propTypes.default.oneOfType([_tshirtSize.allSizes, _propTypes.default.oneOf(['flush'])])
};
HR.defaultProps = {
  distance: 'md'
};
HR.displayName = 'HR';
module.exports = exports.default;